import { authenticatedGet } from "../../api/authenticatedFetch";

const BASE_API = "/api/v1/financial-control";

// getFinancialControlSummary fetches the control-status payload for a period.
// Returns the unwrapped summary object.
export const getFinancialControlSummary = async (params = {}) => {
  const res = await authenticatedGet(`${BASE_API}/summary`, params);
  return res && res.summary ? res.summary : res;
};

// getCalibrationReport fetches the calibration report (coverage + MAPE per source).
export const getCalibrationReport = async () => {
  return authenticatedGet(`${BASE_API}/calibration-report`);
};
